import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'
import axios from '@axios'

export default {
  namespaced: true,
  actions: {
    async createStudentCheckExamination({ commit }, body) {
      try {
        const response = await axios.post('uni/student_check_examination', body)
        const { data } = response
        return {
          isSuccessful: data.code === ApiCode.SUCCESS,
          message: data.message,
        }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async uploadDocument({ commit }, params) {
      try {
        const response = await axios.post('uni/student_check_examination/uploadDocument', params)
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          return { success: true, data: data.data, message: data.message }
        }
        return { success: false, data: [], message: data.message || 'Có lỗi xảy ra!' }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
  },
}
